const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Assignments Manager Directive to display a list or table with tracks to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('assignmentsManager', ['Application', 'Authorization', 'AdminAssignments', 'Assignments', 'AccessHelper', '$translate', function (Application, Authorization, AdminAssignments, Assignments, AccessHelper, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      manager: '=?',
      selectUser: '&?',
      selectContent: '&?',
      newAssignment: '=?',
      user: '=?',
      managerConfiguration: '=?',
      refreshTemplate: '=?',
      refresh: '=?'
    },
    template: require('../../../templates/directives/assignments/assignments-manager.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.authtoken = Authorization.getAuthToken();
      self.user = self.authtoken.user;
      self.directory = {};
      self.features = Application.features.flags();
      self.showArchiveConfirmation = false;
      self.assignments = [];
      self.per_page = 10;
      self.selection = [];
      self.assignmentsRemoved = 0;
      self.loading = false;
      self.clearFilter = false;
      self.translations = {};
      self.assignmentShow = false;
      self.overdue = false;
      self.contentPlaceholder = 'Search Content';
      self.activeSearch = 'users';
      self.multiselect = true;
      self.usersQueryCount = 0;
      self.contentQueryCount = 0;
      self.types = ['articles', 'videos', 'files', 'assessments', 'tracks', 'scorm', 'imported_content', 'workshops', 'users', 'journeys'];
      if ($scope.user) {
        self.types.pop();
      }
      self.searchQuery = {};

      self.requestedTypes = {
        articles: true,
        videos: true,
        files: true,
        tracks: true,
        assessments: true,
        workshops: true
      };

      if (self.features.scorm) {
        self.requestedTypes.scorm = true;
      }

      if (self.features.udemy || self.features.linkedin_learning || self.features.enable_masterclass) {
        self.requestedTypes.imported_content = true;
      }

      if (self.features.presentations) {
        self.requestedTypes.presentations = true;
      }

      if (self.features.journeys) {
        self.requestedTypes.journeys = true;
      }

      self.allTypeList = Object.keys(self.requestedTypes);
      self.allTypeString = self.allTypeList.join(',');

      self.allowance = {
        assign: AccessHelper.isAllowed(['admin', 'assignments', 'create'], null, ['admin', 'creator', 'manager']),
        edit: AccessHelper.isAllowed(['admin', 'assignments', 'edit'], null, ['admin', 'creator', 'manager']),
        view: AccessHelper.isAllowed(['admin', 'assignments', 'view'], null, ['admin', 'creator', 'manager']),
        reset: AccessHelper.isAllowed(['admin', 'assignments', 'reset'], null, ['admin', 'creator', 'manager']),
        archive: AccessHelper.isAllowed(['admin', 'assignments', 'archive'], null, ['admin', 'creator', 'manager']),
        complete: AccessHelper.isAllowed(['admin', 'assignments', 'complete'], null, ['admin', 'creator', 'manager']),
      };

      // Disable specific to manager configuration
      if ($scope.manager && $scope.managerConfiguration) {
        if ($scope.managerConfiguration.disable_assignment_completion) {
          self.disableCompletion = true;
        }
        if ($scope.managerConfiguration.disable_assignment_removal) {
          self.disableRemoval = true;
        }
        if ($scope.managerConfiguration.disable_assignment_edit) {
          self.disableEdit = true;
        }
        if ($scope.managerConfiguration.hide_non_managing_groups) {
          self.hideNonManagingGroups = true;
        }
      }

      if (!self.allowance.assign && !self.allowance.edit && !self.allowance.view && !self.allowance.reset && !self.allowance.archive) {
        Application.navigation.goTo('/explore');
        return;
      }

      self.editMenu = {
        visible: false,
        activeId: null,
        closeHandler: function(){
          self.editMenu.visible = false;
          self.editMenu.activeId = null;
        },
        clickHandler: function(i){
          if (self.editMenu.visible) {
            if (self.editMenu.activeId === i) {
              self.editMenu.visible = false;
              self.editMenu.activeId = null;
            } else {
              self.editMenu.activeId = i;
            }
          } else {
            self.editMenu.activeId = i;
            self.editMenu.visible = true;
          }
        }
      };

      self.status = {
        getColorClass: function(assignment) {
          const {completed, due_date: dueDate, completed_date: completedDate} = assignment;
          const pastDue = !dueDate ? false : new Date(dueDate) < new Date();
          const completedOnTime = new Date(completedDate) < new Date(dueDate);

          return {
            green: completed && (completedOnTime || !dueDate),
            red: !completed && pastDue,
            orange: completed && pastDue,
            yellow: !completed && (!pastDue || !dueDate),
          };
        },
        getHoverText: function(assignment) {
          const colorsToText = {
            green: 'assignmentsManager.completed_on_time',
            red: 'assignmentsManager.pending_past_due',
            orange: 'assignmentsManager.completed_past_due',
            yellow: 'assignmentsManager.pending_on_time',
          }
          const colors = self.status.getColorClass(assignment);
          for (const color in colors) {
            if (colors[color]) {
              return colorsToText[color];
            }
          }
        }
      };

      var getStandardQuery = function(){
        return {
          fields: 'assignee,completed,incomplete,completed_date,due_date,assigned_content,completed_content,createdAt',
          'assigned_content.content_id-populate': 'name,title,type,archived',
          'assignee-populate': 'first_name,last_name,full_name,email',
          page: 1,
          per_page: self.per_page,
          sort: 'createdAt,-1'
        };
      };
      self.query = getStandardQuery();

      self.initialize = function () {
        self.initialized = true;
        self.load();
      };

      self.setAssignment = function(assignment, allowedGroups) {
        var content = [];
        var types = ['article', 'media', 'track', 'scorm', 'imported_content', 'assessment', 'workshop', 'journey'];

        if (self.features.groups) {
          assignment.groups = '';
          // ***Protect against manager settings here***
          if (assignment.assignee && assignment.assignee.groups) {
            assignment.assignee.groups.forEach(function(group) {
              if (allowedGroups && !allowedGroups[group._id]) {
                return;
              }
              if (group.name) {
                if (assignment.groups) {
                  assignment.groups += (' | ' + group.name);
                  return;
                }
                assignment.groups = group.name;
              }
            });
            if (!assignment.groups) {
              assignment.groups = '-----';
            }
          }
        }

        if (assignment.assigned_content && assignment.assigned_content.length) {
          assignment.contents = assignment.assigned_content.map(function(item) {
            if (!$scope.manager || !$scope.selectContent) {
              item.content_id.link = '/explore';
              if(item.content_id && item.content_id.type) {
                item.content_id.link = '/edit/' + self.contentLinkMap[item.content_id.type] + '/' + item.content_id._id;
              }
            }

            return item.content_id;
          });
          return;
        }

        types.forEach(function(item) {
          if (assignment[item]) {
            content.push(assignment[item]);
          }
        });

        assignment.contents = content;
      };

      self.postLoad = function(assignments) {
        var allowedGroups = null;
        self.assignments.length = 0;
        self.assignmentsRemoved = 0;

        if ($scope.manager && $scope.managerConfiguration && self.hideNonManagingGroups) {
          allowedGroups = {};

          var groupList = self.user && self.user.managing_groups || [];
          groupList.forEach(function(group) {
            allowedGroups[group] = true;
          });
        }

        assignments.forEach(function(assignment) {
          self.setAssignment(assignment, allowedGroups);
        });
        self.assignments = assignments;
        self.loading = false;
        self.contentLoading = false;
      };

      var loadRoute = function() {
        var body = JSON.parse(JSON.stringify(self.searchQuery));
        if (self.overdue) {
          body.overdue = true;
        }

        if (self.searchContentList && self.searchContentList.length) {
          body.content = self.searchContentList;
        }

        if ($scope.user) {
          body.users = [$scope.user];
        }

        if ($scope.manager) {
          body.manager_query = true;
        }

        return AdminAssignments.search(self.query, body).$promise;
      };

      self.load = function () {
        self.loading = true;
        self.contentLoading = true;

        loadRoute()
        .then(self.postLoad).catch(function (error) {
          self.loading = false;
          self.contentLoading = false;
          console.log('Error getting assignments:', error);
        });
      };

      self.previous = function () {
        if (self.query.page === 1) {
          return;
        }
        self.query.page--;
        self.load();
      };

      self.next = function () {
        if (self.assignments.length !== self.per_page && !self.assignmentsRemoved) {
          return;
        }
        self.query.page++;
        self.load();
      };

      self.search = function(query) {
        self.usersQueryCount = 0;
        if (query && Object.keys(query).length) {
          var counts = {
            onQuery : Object.keys(query).length,
            total: 0
          };
          var compileTotal = function(){
            Object.keys(query).forEach(function(key) {
              if (key === 'text') {
                counts.total = counts.total + 1;
              } else {
                counts.total = counts.total + query[key].length;
              }
            });
          };
          compileTotal();
          self.usersQueryCount = counts.total;
        }
        self.searchQuery = query;
        self.query.page = 1;
        self.load();
      };

      self.searchContent = function(query) {
        self.contentQueryCount = 0;
        if (query && query.length) {
          self.contentQueryCount = query.length;
        }
        self.searchContentList = query || [];
        self.query.page = 1;
        self.load();
      };

      self.searchItems = {
        placeholder: $scope.user ? 'Search Content' : 'Search Users or Content',
      };

      self.select = function (item) {
        var id = item._id;
        var index = self.selection.indexOf(id);
        if (index === -1) {
          self.directory[id] = item;
          self.directory[id].type = self.directory[id].type ? self.directory[id].type : 'workshop';
          self.selection.push(id);
          return;
        }
        self.selection.splice(index, 1);
        delete self.directory[id];
      };

      self.removeSelections = function() {
        for (var i = self.selection.length - 1; i >= 0; i--) {
          self.select(self.directory[self.selection[i]]);
        }
        self.selection.splice(0);
      };

      self.remindid = {};
      self.remind = function(item) {
        if (self.remindid[item._id]) {
          return;
        }
        self.remindid[item._id] = true;
        Assignments.remind({remindid: item._id}, null).$promise
        .then(function() {
          Application.messaging.addMessage({type: 'success', text: 'A reminder was successfully sent to ' + item.assignee.full_name + '.', duration: 5});
        });
      };
      self.assignmentRemoval = {
        active: null,
        set: function(assignment) {
          this.active = assignment;
        },
        onDelete: function() {
          this.active = null;
          self.load();
        }
      };

      self.manualCompletion = {
        current: null,
        show: false,
        select: function(assignment) {
          self.manualCompletion.current = assignment;
          self.manualCompletion.show = true;
        }
      };

      self.contentLinkMap = {
        assessment: 'assessments',
        video: 'videos',
        file: 'files',
        track: 'tracks',
        scorm: 'scorm',
        importedContent: 'imported-content',
        article: 'articles',
        workshop: 'workshops',
        journey: 'journeys',
      };

      self.goToUser = function(id) {
        if ($scope.manager) {
          if ($scope.selectUser) {
            $scope.selectUser({user: id});
          }
          return;
        }
        Application.navigation.goTo('/edit/users/' + id);
      };

      self.getUserLink = function(userId) {
        return `#/edit/users/${userId}`;
      };

      self.goToContent = function(content) {
        if ($scope.manager && $scope.selectContent) {
          $scope.selectContent({content: content});
          return;
        }
      };

      self.editing = {
        active: null,
        setActive: function(item) {
          if (item.completed_date || !item._id) {
            return;
          }

          self.editing.active = item._id;
        },
        closeEdit: function(changed) {
          self.editing.active = null;
          if (changed) {
            self.load();
          }
        }
      };

      self.cancelAssignment = function() {
        $scope.newAssignment = false;
        $scope.refreshTemplate = true;
        self.load();
      };

      self.onRefresh = function() {
        self.manualCompletion.current = null;
        self.manualCompletion.show = false;
        self.removeSelections();
        self.assignments = [];
        self.query = getStandardQuery();
        self.initialize();
      };

      $scope.$watch('refresh', function(newVal, oldVal) {
        if (!self.initialized || !newVal || newVal === oldVal) {
          return;
        }
        self.onRefresh();
        $scope.refresh = false;
      });

      $translate([
        'assignmentsManager.search_assignments',
        'assignmentsManager.search_assignments_content',
        'adminUserAssigned.item_archived',
        'contentManager.search_placeholder'
      ]).then(function (translations) {
        self.translations = translations;
        $scope.user ? 'Search Content' : 'Search Users or Content',
        self.searchItems.placeholder = $scope.user ? self.translations['assignmentsManager.search_assignments_content'] : self.translations['assignmentsManager.search_assignments'];
        self.initialize();
      });
    }],
    controllerAs: 'assign'
  }
}]);